import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController, ToastController } from 'ionic-angular';
import { AngularFireAuth } from 'angularfire2/auth';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthServices } from "../services";
import { Globals } from '../../../globals';
import { HttpClient } from '@angular/common/http';
import { App } from 'ionic-angular'
import { TranslateService } from '@ngx-translate/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { format } from 'date-fns';

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-register',
  templateUrl: 'register.html',
})
export class RegisterPage {
  public loginForm: any;
  public registerForm: any;
  public hsDate: string = '';

  constructor(public afAuth: AngularFireAuth,
    public fb: FormBuilder,
    public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private authServices: AuthServices,
    public globals: Globals,
    private http: HttpClient,
    public appCtrl: App,
    public translate: TranslateService,
    public afs: AngularFirestore,) {
    let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    this.registerForm = fb.group({
      email: ['', Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEXP)])],
      password: ['', Validators.compose([Validators.required])],
      password_repeat: ['', Validators.compose([Validators.required])],
      phone: ['', Validators.compose([Validators.required])],
      company: ['', Validators.compose([Validators.required])],
      name: ['', Validators.compose([Validators.required])],
      accept_privacy: ['', Validators.compose([Validators.required])],
      address: ['', Validators.compose([Validators.required])],
    });
    //init date for hubspot
    this.hsDate = format(new Date(), 'YYYY-MM-DD');
  }

  send_form: boolean = false;
  error_password_message: string = '';
  _send_form: boolean = false;
  checkPasswordU() {

    if (this.registerForm.value.password.length > 0 && this.registerForm.value.password.length < 8) {
      this._send_form = false;
      this.error_password_message = this.translate.instant('config-users-create-min-chars-contrasena')
    } else if (this.registerForm.value.password == this.registerForm.value.password_repeat) {
      this._send_form = true;
      this.error_password_message = '';
    } else if (this.registerForm.value.password.length > 0 && this.registerForm.value.password_repeat.length >= this.registerForm.value.password.length && this.registerForm.value.password != this.registerForm.value.password_repeat) {
      this._send_form = false;
      this.error_password_message = this.translate.instant('config-users-create-contrasenas-no-iguales')
    } else {
      this.error_password_message = '';
    }
  }

  checkAcceptedPrivacy() {
    if (this.registerForm.value.accept_privacy == true) {
      this.send_form = true;
    } else {
      this.send_form = false;
    }
  }

  register() {
    if (!this.registerForm.valid || !this.send_form || !this._send_form) {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-rellena-todos-campos-formulario'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    } else {
      let loadingPopup = this.loadingCtrl.create({
        spinner: 'crescent',
        content: this.translate.instant('instant-loading')
      });
      loadingPopup.present();
      //iniciar siempre user_email en caso cuando tiene deeplink de pagar
      //bug porque el registro al ser correcto inicia session, al no tener email falla
      //al fallar registro no pasa nada porque esta var siempre se iniciar correcto al recargar app
      this.globals.user_email = this.registerForm.value.email;
      //guardamos las variables en globals para tenerlas en las siguientes paginas
      this.globals.register_address = this.addres_format_google || this.registerForm.value.address;
      this.globals.register_phone = this.registerForm.value.phone;
      this.globals.register_company = this.registerForm.value.company;
      this.globals.register_contact = this.registerForm.value.name;
      //
      this.globals.restaurant_uid = '';

      this.afAuth.auth.createUserWithEmailAndPassword(this.registerForm.value.email, this.registerForm.value.password)
        .then(async authData => {
          //
          authData.user.sendEmailVerification();

          await this.completeRegister(authData);
          loadingPopup.dismiss();
        }, error => {
          var errorMessage: string = error.message;
          let alert = this.alertCtrl.create({
            title: this.translate.instant('instant-registro-incorrecto'),
            message: errorMessage,
          });
          loadingPopup.dismiss().then(() => {
            alert.present();
          });
        });
    }
  }

  addres_format_google: any;
  public handleAddressChange(address) {
    this.addres_format_google = address.formatted_address;
    this.registerForm.value.address = address.formatted_address;
  }

  async completeRegister(authData) {
    if (this.addres_format_google) {//Comprovamos si hay una adress formatada y le ponemos al form. Si no lo hacemos la primera vez no lo encuntra bien.
      this.registerForm.value.address = this.addres_format_google;
    }
    var restaurant_uid = await this.authServices.createRestaurant(this.registerForm.value.name, this.registerForm.value.company, this.registerForm.value.phone, this.registerForm.value.email, this.registerForm.value.address);
    this.globals.restaurant_uid = restaurant_uid;
    await this.globals.getRestaurant(restaurant_uid);
    this.sendSlackRegister();
    //Send to bigquery
    this.globals.sendToBigqueryRegister('register');
    await this.authServices.createUserRestaurant(this.registerForm.value.email, this.registerForm.value.name, authData.user.uid, restaurant_uid);
    await this.authServices.initRestaurant(this.registerForm.value.company);

    await this.authServices.updateUserRolIndvGlobals(authData.user.uid);
    await this.authServices.updateRestaurantUidIndvGlobals(authData.user.uid);

    //this.initRestaurantData();

    //Event snippet for FREE conversion page
    const gtag = window['gtag'];
    gtag('event', 'conversion', {
      'send_to': 'AW-943748294/ghrMCK7apW4QxumBwgM',
    });

    //Register to log, etc..
    this.globals.GAtrackView('Register', 'Register', this.registerForm.value.email, 'Register', 'Register', 'Register', '');

    //Save info sherlock to restaurant
    await this.http.get('https://sherlock.mycheftool.com/saveToRestaurant?uid_restaurant=' + this.globals.restaurant_uid, {}).subscribe(async data => {

    },
      err => {
      }
    );
    //push setup page
    window.location.reload();
  }

  openLogin() {
    //this.navCtrl.setRoot(LoginPage);
    this.authServices.page_show = 'login';
  }

  async sendSlackRegister() {
    //generate msg
    var msg = 'Registro del establecimiento: ' + this.registerForm.value.company + ' - ' + this.registerForm.value.email + ' - ' + this.registerForm.value.phone;
    //send
    await this.http.post(this.globals.api_path + 'slack/register', {
      msg: msg,
    }, {}).subscribe(async data => {
    },
      err => {
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/pages/auth/register/register.ts